<section class="como-comprar">
	<iframe src="assets/documents/PROCESO-DE-COMPRA-DE-PRODUCTOS-PAWERFUL.COM.pdf#toolbar=0" frameborder="0"></iframe>	
	<iframe src="assets/documents/PROCESO-DE-COMPRA-DE-PRODUCTOS-LOCAL-CDMX &-AREA-METROPOLITANA -PAWERFULCOM.pdf#toolbar=0" frameborder="0"></iframe>	
	
	<iframe src="assets/documents/PROCESO-DE-COMPRA-DE-PRODUCTOS-FORANEA-PAWERFULCOM.pdf#toolbar=0" frameborder="0"></iframe>	
</section>
<style>
	.como-comprar{
		width: 80%;
		margin: 40px auto;
	}
	.como-comprar > iframe{
		width: 100%;
		height: 80vh;
		margin-bottom: 20px;
	}
</style>